import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useForm, FormProvider } from 'react-hook-form'
import SubFormLayout from 'components/layouts/SubFormLayout'
import { Stack } from '@mui/material'
import { chunk } from 'lodash'

const complianceFields = [
  [
    {
      name: 'paymentHoldTime',
      label: 'Payment Hold Time',
      dataTest: 'payment-hold-time',
      fieldType: 'static',
    },
  ],
  // commented out until v2 of payment holds
  // [
  //   {
  //     name: 'paymentMethods',
  //     label: 'Payment Hold Methods',
  //     dataTest: 'payment-hold-methods',
  //     fieldType: 'static',
  //   },
  // ],
]

const fields = chunk(
  [
    {
      name: 'materialName',
      label: 'Material Name',
      dataTest: 'material-name',
      fieldType: 'static',
    },
    {
      name: 'commodityName',
      label: 'Commodity Name',
      dataTest: 'commodity-name',
      fieldType: 'static',
    },
    {
      name: 'materialCode',
      label: 'Material Code',
      dataTest: 'material-code',
      fieldType: 'static',
    },
    {
      name: 'isriCode',
      label: 'ISRI Code',
      dataTest: 'material-isri',
      fieldType: 'static',
    },
    {
      name: 'accountingCode',
      label: 'Income Code',
      dataTest: 'accounting-code',
      fieldType: 'static',
    },
    {
      name: 'accountingExpenseCode',
      label: 'Expense Code',
      dataTest: 'accounting-expense-code',
      fieldType: 'static',
    },
    {
      name: 'tareWeightRequired',
      label: 'Tare Weight Required?',
      dataTest: 'material-tare-weight-required',
      fieldType: 'static',
    },
    {
      name: 'materialNotes',
      id: 'materialNotes',
      label: 'Notes',
      dataTest: 'material-notes',
      fieldType: 'static',
      InputProps: {
        multiline: true,
        rows: 3,
      },
    },
  ],
  2,
)

const MaterialProperties = ({ defaultValues }) => {
  const methods = useForm()
  const { enableMaterialPaymentHolds } = useSelector(state => state.featureFlags?.variables || {})
  useEffect(() => {
    methods.reset(defaultValues)
  }, [defaultValues])

  return (
    <>
      <FormProvider {...methods}>
        <Stack>
          <Stack direction="row" py={3} px={2} spacing={3} justifyContent="space-between">
            <SubFormLayout formName="Material Properties" fields={fields} boxStyles={{ width: '49%' }} />
            {enableMaterialPaymentHolds && (
              <SubFormLayout formName="Compliance" fields={complianceFields} boxStyles={{ width: '49%' }} />
            )}
          </Stack>
        </Stack>
      </FormProvider>
    </>
  )
}

MaterialProperties.propTypes = {
  defaultValues: PropTypes.object.isRequired,
}

export default MaterialProperties
